import { Component, Vue } from "vue-property-decorator";
import Util from "@/ts/Util";
import { BackButton, Flag } from "@/types/ChooseVoucher";

import HeaderColor from "orders-module/src/components/HeaderColor.vue";

@Component({
  components: { HeaderColor },
})
export default class ChooseVoucher extends Vue {
  backButton: BackButton = {
    iconClass: "fas",
    icon: "chevron-left",
    callback: this.goBack,
  };
  flags: Flag[] = [
    {
      id: 0,
      text: "Alelo Refeição",
      flag: "alelo",
    },
    {
      id: 1,
      text: "Sodexo Refeição",
      flag: "sodexo",
    },
    {
      id: 2,
      text: "VR Refeição",
      flag: "vr",
    },
  ];

  mounted() {
    Util.setBackButtonBehavior(this.goBack);
  }

  goBack() {
    this.$router.go(-1);
  }

  selectVoucher(id: number) {
    const flag = this.flags.find((flag: Flag) => flag.id === id);
    if (flag) {
      sessionStorage.setItem("VOUCHER_FLAG", flag.flag);
      this.$router.push({ name: "AddCard" });
    }
  }
}
